import axios from "./axios";
export default {
  /**
   * @deprecated 弃用
   * @param {*} array 
   * @param {*} gt 
   * @returns 
   */
  mylist(array, gt) {
    return axios.post("/api/black/mylist/submit", {
      name: array.name,
      qq: array.qq,
      server: array.server,
      phone: array.phone,
      time: array.time,
      level: array.level,
      info: array.info,
      ...gt
    });
  },
  /**
   * @deprecated 弃用
   * @param {*} array 
   * @param {*} gt 
   * @returns 
   */
  public(array, gt) {
    let img = JSON.stringify(array.images);
    return axios.post("/api/black/publiclist/submit", {
      name: array.name,
      qq: array.qq,
      server: array.server,
      phone: array.phone,
      time: array.time,
      level: array.level,
      info: array.info,
      images: img,
      ...gt
    });
  },
  submit(array, fileArray) {
    let formData = new FormData();
    formData.append("data", JSON.stringify(array));
    if (fileArray) {
      for (let i = 0; i < fileArray.length; i++) {
        formData.append("upload[]", fileArray[i]);
      }
    }
    return axios.post("/api/black/upload", formData);

  }
  
};